<template lang="pug">
  LayoutDefault
    .page: .container-fluid
      .section: .card: .card--body
        .heading--section Withdrawal History

        .pad_t--20.pad_b--5
          .row.align-items-center
            .col-xl-3(v-if="enums.clientCodes.length > 1")
              .text--size_13.text--color_grey.pad_b--5.pad_l--5 Client Code
              b-form-select(v-model="clientCode", :options="enums.clientCodes", @input="CLIENTCODE_UPDATED", :disabled="!hasWithdrawals")

            .w-100(v-if="enums.clientCodes.length > 1")

            .col-lg-6.col-xl-3.pad_t--15
              .text--size_13.text--color_grey.pad_b--5.pad_l--5 Requested by
              b-form-select(v-model="filter.requestedBy", :options="enums.requestedBy", @input="REQUESTEDBY_UPDATED", :disabled="!hasWithdrawals")

            .col-lg-6.col-xl-3.pad_t--15
              .text--size_13.text--color_grey.pad_b--5.pad_l--5 Withdrawal Request Status
              b-form-select(v-model="filter.status", :options="statuses", :disabled="!hasWithdrawals")

            .col-lg-6.col-xl-3.pad_t--15
              .text--size_13.text--color_grey.pad_b--5.pad_l--5 Month
              b-form-select(v-model="filter.month", :options="enums.months", :disabled="!hasWithdrawals")

            .col-lg-6.col-xl-3.pad_t--15.align__right-md(v-if="hasFilter")
              .text--size_13.text--color_grey.pad_b--5.hidden_md &nbsp;
              button.button.button-neutral(@click="CLEAR_FILTER") Clear Filter
              

        .pad_t--25
          Loading(:isLoading="isDataLoading", type="bar")
            template(v-if="hasWithdrawals")
              table.newtable.break-lg
                thead.align__center
                  tr
                    td Time
                    td Transaction ID
                    td Client Code
                    td Requested By
                    td Amount (RM)
                    td Status
                    td Expected Payment Date
                tbody.align__center
                  tr(v-for="r in withdrawalsCleaned")
                    td(data-label="Time"): span {{ r.time }}
                    td(data-label="Transaction ID"): span
                      template(v-if="r.shortId")
                        span(v-tooltip="`${r.id}`")
                          span.id {{ r.shortId }}
                    td(data-label="Client Code"): span {{ r.clientCode }}
                    td(data-label="Requested By"): span {{ r.requestedBy }}
                    td(data-label="Amount"): span RM {{ r.amount | twoDecimal }}
                    td(data-label="Status"): span
                      template(v-if="r.requestedBy === 'Client'")
                        .statusNegative(v-if="r.status === 'Rejected'")
                          span.statusIcon: font-awesome-icon(icon="times")
                          | Rejected
                        .statusPending(v-if="r.status === 'Pending'")
                          span.statusIcon: font-awesome-icon(icon="spinner")
                          | Pending
                        .statusPositive(v-if="r.status === 'Submitted'") 
                          span.statusIcon: font-awesome-icon(icon="check")
                          | Submitted
                      template(v-if="r.requestedBy === 'Remisier'")
                        .statusPositive(v-if="r.status === 'Submitted'")
                          span.statusIcon: font-awesome-icon(icon="check")
                          | Submitted
                        .statusPending(v-if="r.status === 'Pending'")
                          span.statusIcon: font-awesome-icon(icon="spinner")
                          | Pending
                    td(data-label="Expected Payment Date"): span
                      template(v-if="r.expectedPaymentDate") {{ r.expectedPaymentDate }}
                      template(v-else) -

            template(v-else)
              MessageBar(type="warning") 
                | No records found, you have yet to make a withdrawal. &nbsp;
                router-link(:to="{ name: 'withdrawal' }") Make an E-withdrawal

            .pad_t--15.pad_t--0-lg(v-if="hasWithdrawals && withdrawalsCleaned.length === 0")
              MessageBar(type="warning") 
                | No records found, please change the filter criteria.

</template>



<script>
  import { mapState } from 'vuex';
  import * as moment from 'moment';
  import { VTooltip } from 'v-tooltip'

  import { generateMonthOptions } from '@/lib/helper';
  import Loading from '@/components/Loading';
  import MessageBar from '@/components/MessageBar.vue';
  import requestHandlers from '@/mixins/requestHandlers';
  import allFilters from '@/lib/filters';

  export default {
    name: 'withdrawalHistory',

    mixins: [requestHandlers],
    
    components: {
      Loading, MessageBar,
    },

    directives: {
      tooltip: VTooltip,
    },

    filters: {
      twoDecimal: allFilters.twoDecimal,
    },

    data: () => ({
      clientCode: null,
      withdrawals: [],

      filter: {
        month: null,
        status: null,
        requestedBy: 'Client',
      },

      enums: {
        clientCodes: [],
        months: [],
        requestedBy: [
          { text: "Client", value: "Client" },
          { text: "Remisier", value: "Remisier" },
        ],
      }
    }),


    computed: {
      ...mapState('auth', [
        'currentUser'
      ]),

      hasWithdrawals() {
        return this.withdrawals.length > 0;

      },

      hasFpxEligibleAccounts() {
        return this.currentUser.fpxEligibleAccounts.length > 0;
      },

      statuses() {
        let _array = [
          { text: 'Select Status', value: null }
        ];

        if(this.filter.requestedBy === 'Client') {
          _array.push({ text: "Pending", value: "Pending" });
          _array.push({ text: "Submitted", value: "Submitted" });
          _array.push({ text: "Rejected", value: "Rejected" });
        }

        if(this.filter.requestedBy === 'Remisier') {
          _array.push({ text: "Pending", value: "Pending" });
          _array.push({ text: "Submitted", value: "Submitted" });
        }

        return _array;
      },

      hasFilter() {
        let hasFilter = false;

        Object.keys(this.filter).forEach(key => {
          if(this.filter[key] !== null && key !== 'requestedBy') {
            hasFilter = true;
          }
        })

        return hasFilter;
      },

      withdrawalsCleaned() {
        return this.withdrawals
          .map(r => {
            let { requestedBy, withdrawalStatus, expectedPaymentDate } = r;

            requestedBy = requestedBy.charAt(0).toUpperCase() + requestedBy.slice(1).toLowerCase();
            withdrawalStatus = withdrawalStatus.charAt(0).toUpperCase() + withdrawalStatus.slice(1).toLowerCase();
            expectedPaymentDate = expectedPaymentDate ? moment(r.expectedPaymentDate).format('DD-MM-YYYY') : null;

            let shortId = r.transactionId ? r.transactionId.substring(0, 10) + '...'  : '';

            let _obj = {
              time: moment(r.requestedAt).format('DD-MM-YYYY'),
              shortId: shortId,
              id: r.transactionId,
              clientCode: r.clientCode,
              requestedBy: requestedBy,
              amount: r.withdrawalAmount,
              status: withdrawalStatus,
              expectedPaymentDate: expectedPaymentDate,
            }

            return _obj;
          })

          .filter(r => {
            let _passStatus = true;
            let _passMonth = true;
            let _passRequestedBy = true;

            if(this.filter.status && this.filter.status !== r.status) {
              _passStatus = false;
            }

            if(this.filter.month && this.filter.month !== moment(r.time, 'DD-MM-YYYY').format('YYYY-MM')) {
              _passMonth = false;
            }

            if(this.filter.requestedBy && this.filter.requestedBy !== r.requestedBy) {
              _passRequestedBy = false;
            }

            return _passStatus && _passMonth && _passRequestedBy;
          });
      },
    },



    methods: {
      REQUESTEDBY_UPDATED() {
        this.filter.status = null;
      },

      CLEAR_FILTER() {
        Object.keys(this.filter).forEach(key => {
          if(key === 'requestedBy') {
            return;
          }

          this.filter[key] = null;
        })
      },

      CLIENTCODE_UPDATED() {
        this.FETCH_RECORDS();
        this.CLEAR_FILTER();
      },

      async FETCH_RECORDS() {
        this.REQUEST_INIT();

        try {
          let { data: { withdrawalHistories } } = await this.$axios.get('api/withdrawal/withdrawalhistory', {
            params: {
              clientcode: this.clientCode
            }
          });

          this.withdrawals = withdrawalHistories;

        } catch(error) {
          this.HANDLE_ERROR_GENERIC(error);

        } finally {
          this.REQUEST_FINALLY();

        }
      }
    },


    created() {
      this.enums.months = generateMonthOptions();

      // For withdrawal, can proceed only if has fpx-elligible client codes
      // Because backend too lazy to come up with appropriate properties
      if(this.hasFpxEligibleAccounts) {
        this.enums.clientCodes = this.currentUser.fpxEligibleAccounts.map(r => r.clientCode);
        this.clientCode = this.enums.clientCodes[0];
        this.FETCH_RECORDS();
      }
    }
  }

</script>